import TicketService from '@/services/apis/tickets'
import moment from '@/libs/moment'

const { getReadTickets, getUnreadTickets } = new TicketService()

export default {

  data() {
    return {
      show: true,
      readTicketShow: false,
      unReadtickets: [],
      readTickets: [],
      unReadTicketPagination: {},
      currentUnreadPage: 1,
      per_page: 10,
      page: 1,
      totalReadTickets: 0,
      openTicketSearch: '',
      closedTicketSearch: '',
      timer: null,
      ticketNameSort: '',
      ticketTypeSort: '',
    }
  },

  computed: {
    searchedUnreadTicket() {
      return this.unReadtickets.filter(item => JSON.stringify(item).toLowerCase().includes(this.openTicketSearch.toLowerCase()))
    },
    openedfields() {
      return [
        { key: 'id', label: this.$t('id') },
        { key: 'title', label: this.$t('title') },
        { key: 'status_value', label: this.$t('status') },
        { key: 'created_at', label: this.$t('date') },
        { key: 'actions', label: this.$t('actions') },
      ]
    },
    closedfields() {
      return [
        { key: 'id', label: this.$t('id') },
        { key: 'title', label: this.$t('title'), sortable: true },
        { key: 'created_at', label: this.$t('date') },
        { key: 'actions', label: this.$t('actions') },
      ]
    },
  },

  watch: {
    async page() {
      await this.getReadTickets()
    },
    openTicketSearch() {
      this.currentUnreadPage = 1
    },
    readTicketShow() {
      setTimeout(() => {
        this.readTicketShow = false
      }, 6000)
    },
  },

  async created() {
    await this.getReadTickets()
    await this.getUnreadTickets()
  },

  methods: {
    onRowSelected(item) {
      this.$router.push(`/${this.$i18n.locale}/tickets/${item.id}`)
    },

    getReadTickets() {
      this.readTicketShow = true
      this.show = true
      return getReadTickets({
        page: this.page,
        per_page: this.per_page,
        search: this.closedTicketSearch,
        sort: this.ticketNameSort,
        sort_type: this.ticketTypeSort,
      })
        .then(({ data }) => {
          this.readTickets = data.results.data
          this.totalReadTickets = data.results.total
        })
        .finally(() => {
          this.readTicketShow = false
          this.show = false
        })
    },

    getUnreadTickets() {
      this.show = true
      return getUnreadTickets()
        .then(({ data }) => {
          this.unReadtickets = data.results
        })
        .finally(() => {
          this.show = false
        })
    },

    closedSearch() {
      clearTimeout(this.timer)

      this.timer = setTimeout(async () => {
        await this.getReadTickets()
      }, 1500)
    },

    rowClass(item, type) {
      if (item && type === 'row') {
        if (item.user_read === '0') {
          return 'unread-background-color'
        }
      }
      return null
    },

    async sortChanged(e) {
      this.readTicketShow = true
      if (e.sortBy === 'category_title') {
        this.ticketNameSort = 'ticket_category_id'
      } else {
        this.ticketNameSort = e.sortBy
      }
      if (e.sortDesc) {
        this.ticketTypeSort = 'DESC'
      } else {
        this.ticketTypeSort = 'ASC'
      }
      await this.getReadTickets()
      setTimeout(() => {
        this.readTicketShow = false
      }, 500)
    },
    getFormattedDate(date) {
      return moment(date).format('YYYY-MM-DD')
    },
  },
}
